<template>
    <v-container>
		<v-row v-if="hasData">
			<v-col cols="6" v-for="(sensor, index) in deviceSensor" :key="sensor.sensorName">
				<apexchart
					:ref="sensor.sensorName"
					type="line"
					height="160"
					:options="optionsSensor(sensor.sensorName, index)"
					:series="dataSensor(sensor.sensorName, index)"
				>
				</apexchart>
			</v-col>
		</v-row>
		<v-alert
			v-if="false"
			dense
			outlined
			type="error"
		>
			No se encuentran <strong>datos</strong> para el dia <strong> {{viewDate | dateFormat}} </strong>
		</v-alert>
		<v-row v-if="isLoading">
			<v-col cols="6" v-for="sensor in countDeviceSensors" :key="sensor">
				<v-skeleton-loader
					type="image"
				></v-skeleton-loader>
			</v-col>
		</v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'
	import VueApexCharts from 'vue-apexcharts'

	export default {
		name: 'Sensors',

		data: () => ({
			chartOptions: {
				chart: {
					id: 'te',
					group: 'social',
					type: 'line',
					height: 160
				},
				colors: ['#777DA7'],
				stroke: {
					width: [2],
					curve: 'straight'
				},
				yaxis: {
					labels: {
						minWidth: 40
					},
					title: {
						text: ''
					},
				},
				xaxis: {
					type: 'datetime',
					tickAmount: 1,
					labels: {
						show: true,
						datetimeUTC: false,
						format: 'HH:mm:ss',
					}
				},
				tooltip: {
					x: {
						format: "HH:mm:ss"
					}
				},
			},
			sensorsChartOptions: {},
			isNull: false,
			colorArray : ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
				'#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
				'#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
				'#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
				'#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
				'#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
				'#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
				'#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
				'#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
				'#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
			]
        }),
		
		methods: {
			dataSensor (sensor, index) {
				const data = this.devicesDateReport.filter( e => {
					return e.sensorName === sensor
				})
				
				let seriesSensor = []

				if (data.length === 0)
					return []
					
				for (let i = 0; i < data.length; i++) {
					seriesSensor.push({
						x: new Date(data[i].ts).getTime(),
						y: Number.parseFloat(data[i].report.avg).toFixed(2)
					})
				}

				if (index + 1 === this.deviceSensor.length) {
					this.$store.dispatch('handleLoading', false)
				}

				return [
					{
						type: 'line',
						name: sensor,
						data: seriesSensor
					}
				]
			},

			viewSensor ({sensorName}) {
				const userViewSensor = this.$store.getters.sensor(this.$route.params.id, sensorName)
				const data = this.devicesDateReport.report

				if (userViewSensor === undefined || data.length === 0)
					return false

				return data[0][sensorName] !== undefined
			},

			optionsSensor (sensor, index) {
				let options = this.chartOptions
				const sensorData = this.sensors.find(e => {
					return e.sensorName === sensor && e.deviceId === this.deviceId
				})

				options.chart.id = sensor
				options.colors = [this.colorArray[index + 8]]

				let sensorDescription = null

				if (sensorData === undefined) {
					sensorDescription = sensor
					return options
				}

				const hastDescription = sensorData.description.length === 0
				sensorDescription = `${hastDescription ? sensor : sensorData.description} ${sensorData.unit}`

				return options
			},
		},

		computed: {
			viewDate () {
				return this.$store.getters.viewDate
			},

			isLoading () {
				return this.$store.getters.isLoading
			},

			deviceId () {
				return this.$route.params.id
			},
			hasData () {
				if (this.devicesDateReport === null || this.devicesDateReport === undefined)
					return false

				if (this.devicesDateReport.length === 0)
					return false
					
				return Object.entries(this.devicesDateReport).length !== 0
			},

			devices () {
				return this.$store.getters.devices
			},

			sensors () {
				return this.$store.getters.sensors
			},

			devicesInfo () {
				return this.$store.getters.devicesInfo
			},

			viewRecord () {
                return this.$store.getters.record
			},

			devicesDateReport () {
                return this.$store.getters.devicesDateReport
			},
			
			device () {
				return this.$store.getters.device(this.deviceId)
			},

			deviceSensor () {
				return this.device.sensors
			},

			countDeviceSensors () {
				return this.sensors.filter( e => {
					return e.deviceId === this.deviceId && e.viewUser
				}).length
			}
		},

		watch: {
			hasData (val) {
				if (!val) {
					this.$store.dispatch('handleLoading', false)
					this.$store.dispatch('customNotification', {
						text: 'No existen datos para este dia',
						color: 'error'
					})
				}
			},
		},

		filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LL')
			},
		},

		components: {
			apexchart: VueApexCharts
		},

		created () {
			moment.locale('es-us')
		}

	}
</script>
